import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Form               from 'app/components/forms/form';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';

import ProgramAppForm from 'app/components/grant-system/program-app-form';
import GrantSysDuck from 'app/ducks/grants-system';

class PageGrantApp extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {program, app} = this.props;
    const title = program ? `Application | ${program.title}` : 'Application';

    return (
      <MainLayout className="page-form">
        <Meta title={`${title} | Millie`} />
        {!!(program && app) && (
          <ProgramAppForm program={program} app={app} />
        )}
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  app: GrantSysDuck.Slx.pathApp(state),
  program: GrantSysDuck.Slx.pathAppProgram(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageGrantApp);
